{
	"no-face-detected": "Nie wykryto twarzy",
	"try-a-different-image": "Spróbuj z innym obrazem"
}
